import { render, staticRenderFns } from "./PartnerEntityVimeTab.vue?vue&type=template&id=617df6a6"
import script from "./PartnerEntityVimeTab.vue?vue&type=script&lang=js"
export * from "./PartnerEntityVimeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports